export function escapeCsvCell(value) {
    const s = value == null ? '' : String(value);
    return s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')
        ? `"${s.replace(/"/g, '""')}"`
        : s;
}
function formatExportTimestamp(date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}`;
}
function formatGeneratedLabel(date) {
    return date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
}
/** `answered_calls_by_agents` → `Answered Calls By Agents` */
export function humanizeExportFilename(filename) {
    return filename
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\b\w/g, (c) => c.toUpperCase());
}
export function formatExportFilename(base, withTimestamp = true) {
    const safe = base.replace(/[^\w-]+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
    if (!withTimestamp)
        return safe || 'export';
    return `${safe || 'export'}_${formatExportTimestamp(new Date())}`;
}
export function buildCsvContent({ filename, title, headers, rows, includeMetadata = true, }) {
    const lines = [];
    const displayTitle = title ?? humanizeExportFilename(filename);
    if (includeMetadata) {
        lines.push(escapeCsvCell(`Call Center CRM — ${displayTitle}`));
        lines.push(['Generated', formatGeneratedLabel(new Date())].map(escapeCsvCell).join(','));
        lines.push(['Records', String(rows.length)].map(escapeCsvCell).join(','));
        lines.push('');
    }
    lines.push(headers.map(escapeCsvCell).join(','));
    for (const row of rows) {
        lines.push(row.map(escapeCsvCell).join(','));
    }
    return lines.join('\r\n');
}
export function downloadCsvContent(content, filenameBase, timestampFilename = true) {
    const blob = new Blob(['\uFEFF', content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${formatExportFilename(filenameBase, timestampFilename)}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
}
export function exportReportCsv(options) {
    downloadCsvContent(buildCsvContent(options), options.filename, options.timestampFilename ?? true);
}
export function downloadBlob(blob, filename) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
}
